import { DateTime } from 'luxon';
import { Model } from 'pinia-orm';
import { BelongsTo, MorphMany, Num, Str } from 'pinia-orm/dist/decorators';
import Comment from './Comment';
import Package from './Package';
import Project from './Project';
import User from './User';

export const PurchaseOrderStatus = {
  draft: 0,
  paid: 10,
  cancelled: 20,
} as const;

export const PurchaseOrderStatusTitles = {
  draft: 'Draft',
  paid: 'Paid',
  cancelled: 'Cancelled',
};

export const PurchaseOrderStatusBadgeClasses = {
  draft: 'bg-amber-100 border-amber-200 text-amber-800',
  paid: 'bg-green-100 border-green-200 text-green-800',
  cancelled: 'bg-gray-100 border-gray-200 text-gray-800',
} as const;

export default class PurchaseOrder extends Model {
  static entity = 'App\\Models\\PurchaseOrder';

  @Num(0)
  declare id: number;
  @Num(0)
  declare project_id: number;
  @Num(undefined)
  declare package_id: number | undefined;
  @Num(0)
  declare user_id: number;
  @Str('')
  declare code: string;
  @Str('')
  declare description: string;
  @Num(undefined)
  declare amount: number | undefined;
  @Num(undefined)
  declare actual_cost: number | undefined;
  @Str('')
  declare contractor_ref: string | undefined;
  @Str('')
  declare date: string;
  @Num(undefined)
  declare status: ObjectValues<typeof PurchaseOrderStatus>;
  @Str('')
  declare paid_at: string | undefined;
  @Str('')
  declare cancelled_at: string | undefined;
  @Str('')
  declare created_at: string;
  @Str('')
  declare updated_at: string;
  @BelongsTo(() => Project, 'project_id', 'id')
  declare project: Project;
  @BelongsTo(() => Package, 'package_id', 'id')
  declare package: Package | null;
  @BelongsTo(() => User, 'user_id', 'id')
  declare user: User;
  @MorphMany(() => Comment, 'commentable_id', 'commentable_type', 'id')
  declare comments: Comment[];

  get createdAt(): DateTime {
    return DateTime.fromISO(this.created_at);
  }

  get orderDate(): DateTime | undefined {
    return this.date ? DateTime.fromISO(this.date) : undefined;
  }

  get paidAt(): DateTime | undefined {
    return this.paid_at ? DateTime.fromISO(this.paid_at) : undefined;
  }

  get cancelledAt(): DateTime | undefined {
    return this.cancelled_at ? DateTime.fromISO(this.cancelled_at) : undefined;
  }
}
